import { Component, Input, inject } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { ICustomformField } from '@df/catalog/customform/customform';
import { GridColumnDirective } from '@df/ui/atomic/atom/grid/grid-column.directive';
import { GridDirective } from '@df/ui/atomic/atom/grid/grid.directive';
import { OrderByPipe } from '@df/ui/common/order-by.pipe';
import { AddressFieldsetComponentDef } from '@df/ui/form/address-fieldset.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { FormMuiFieldComponent } from '../../../common/form/mui-field/form-mui-field.component';
import { CustomformGoogleMapsAddressAutocompleteDirective } from '../google-maps-address-autocomplete/customform-google-maps-address-autocomplete.directive';

@Component({
    selector: 'customform-address-fieldset',
    templateUrl: 'customform-address-fieldset.html',
    styleUrl: 'customform-address-fieldset.scss',
    imports: [
        FormMuiFieldComponent,
        FormsModule,
        GridDirective,
        GridColumnDirective,
        OrderByPipe,
        TranslationModule,
        CustomformGoogleMapsAddressAutocompleteDirective
    ],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CustomformAddressFieldsetComponent extends AddressFieldsetComponentDef {
    @Input({ required: true })
    customFormField!: ICustomformField;

    override type = undefined;

    override form = inject(ControlContainer) as NgForm;

    override ngOnInit(): void {
        super.ngOnInit();
        this.dfApiConfigService
            .loadCountries()
            .then(() => {
                this.syncCountries();
                this.detectChanges();
            })
            .catch(() => {});
    }

    protected get displayAddress(): boolean {
        return this.customFormField.show_address === 1;
    }

    protected get displayCity(): boolean {
        return this.customFormField.show_city === 1;
    }

    protected get displayCountry(): boolean {
        return this.customFormField.show_country === 1;
    }

    protected get displayRegion(): boolean {
        return this.customFormField.show_state === 1;
    }

    protected get displayPostcode(): boolean {
        return this.customFormField.show_zipcode === 1;
    }

    protected get isSM(): boolean {
        return this.app.client.sizeId < 2;
    }
}
